import "./OrderEntryLinkComponents.scss";
import template from "./OrderEntryLinkComponents.html";
import {IComponentOptions, IOnDestroy, IRootElementService} from "angular";
import {Observable, ReplaySubject, Subject} from "rxjs";
import {CurrentUserService} from "../../../services/user/CurrentUserService";
import {FeatureNames} from "../../../types/UserConfig";
import {PlaceOrderService} from "../../../portfolio/templates/ticket/services/PlaceOrderService";
import {CodeAndExchange} from "../../../instruments/types/CodeAndExchange";
import {OrderSide} from "../../models/OrderRecord";
import {AccountId} from "../../../account/types/AccountRecord";

export const OrderEntryLink = "tfOrderEntryLink";

export function orderEntryLink(): IComponentOptions {
    return {
        template,
        bindings: {
            security: "<",
            quantity: "<",
            side: "<",
            limit: "<",
            accountId: "<"
        },
        transclude: true,
        controllerAs: "ctrl",
        controller: OrderEntryLinkComponentsController
    };
}

export class OrderEntryLinkComponentsController implements IOnDestroy {

    public readonly security?: CodeAndExchange;
    public readonly quantity?: number;
    public readonly side?: OrderSide;
    public readonly limit?: number;
    public readonly accountId?: AccountId;

    public readonly enabled$: Observable<boolean>;
    private readonly openOrder$ = new Subject<boolean>();

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(private readonly $element: IRootElementService,
                       private readonly currentUserService: CurrentUserService,
                       private readonly placeOrderService: PlaceOrderService) {
        this.enabled$ = currentUserService.current
                                          .takeUntil(this.destroyed$)
                                          .map((user) => user.hasFeature(FeatureNames.FEATURE_ORDER_ENTRY));
        this.enabled$.subscribe((enabled) => {
            if (enabled) {
                $element.addClass("enabled");
            } else {
                $element.removeClass("enabled");
            }
        });

        this.watchOpenOrder();
    }

    private watchOpenOrder() {
        this.openOrder$
            .takeUntil(this.destroyed$)
            .withLatestFrom(this.enabled$)
            .filter(([ignored, enabled]) => enabled)
            .subscribe((ignored) => this.openPlaceOrderDialog());
    }

    private openPlaceOrderDialog() {
        const order = {
            code: this.security?.code,
            exchange: this.security?.exchange,
            quantity: this.quantity,
            limit: this.limit,
            side: this.side
        };
        this.placeOrderService.openEquityOrderWindow(order, this.accountId);
    }

    public openOrder() {
        this.openOrder$.next(true);
    }

    public $onDestroy() {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }
}
